module.exports = __webpack_public_path__ + "img/ring_g_i_0_1.a42f0971.png";